export default __webpack_public_path__ + "static/media/DMSans-Italic.63d6efd0.ttf";